<div class="mat-icon-overlay-icon" cdkOverlayOrigin #origin="cdkOverlayOrigin" (mouseenter)="showOverlay()" (mouseleave)="cancelOverlay()">
  @if (icon) {
    <i [nimbusIcon]="icon" class="triangle-overlay-icon"></i>
  }
  @if (name) {
    <span>{{ name }}</span>
  }
  @if (hasTextDisplayed) {
    <ng-container [ngTemplateOutlet]="textTemplate"></ng-container>
  }
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayDelay
  [cdkConnectedOverlayPanelClass]="[panelClass, isMediumSize ? 'icon-connected-overlay-medium' : 'icon-connected-overlay']"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  (positionChange)="onPositionChange($event)"
  (attach)="overlayOpened()"
  (detach)="overlayClosed()"
>
  <div
    class="nimbus-tooltip-complex flex-container tooltip-content"
    [ngClass]="cdkArrowCssClass$ | async"
    cdkTrapFocus
    cdkTrapFocusAutoCapture="true"
  >
    <div class="mat-icon-overlay-view">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
